import layoutMain from '../../components/layout/LayoutMain'
export default [
    {
        path: '/user',
        name: 'user',
        redirect: {
            name: 'user.center'
        },
        component: layoutMain,
        children: [
            // 个人中心
            {
                path: 'center',
                name: 'user.center',
                meta: {
                    noheader: true,
                    hasBottom: true,
                    unPullRefresh: true,
                    pr0:true,
                    pl0:true,
                    usercenter:true
                },
                component: () => import('./UserCenter')
            },
            // 登录注册
            {
                path: 'login',
                name: 'user.login',
                meta: {
                    title: '登录/注册',
                    my: true,
                    hasBottom: true,
                    header2: true
                },
                component: () => import('./UserLogin')
            },
            // {
            //     path: 'register',
            //     name: 'user.register',
            //     meta: {
            //         title: '我的',
            //         my: true
            //     },
            //     component: () => import('./UserRegister')
            // },
            // identity
            {
                path: 'identity',
                name: 'user.identity',
                meta: {
                    title: '实名认证',
                    my: true,
                    header2: true
                },
                component: () => import('./UserIdentity')
            },
            // 帮助中心
            {
                path: 'faq',
                name: 'user.faq',
                meta: {
                    title: '帮助中心',
                    my: true,
                    header2: true
                },
                component: () => import('./UserFaq')
            },
            {
                path: 'faq/detail',
                name: 'faq.detail',
                meta: {
                    title: '帮助中心',
                    my: true,
                    header2: true
                },
                component: () => import('./FaqDetail')
            },
            //角色绑定
            {
                path: 'bind',
                name: 'user.bind',
                meta: {
                    title: '角色绑定',
                    unPullRefresh: true,
                    my: true,
                    pr0: true,
                    header2: true,
                },
                component: () => import('./UserBind')
            },
            //角色绑定  绑定
            {
                path: 'bind/role',
                name: 'user.bindrole',
                meta: {
                    title: '游戏账号绑定',
                    my: true,
                    pr0: true,
                    header2: true,
                },
                component: () => import('./bind/UserBind1')
            },
            //设置
            {
                path: 'setting',
                name: 'user.setting',
                meta: {
                    title: '设置',
                    my: true,
                    header2: true
                },
                component: () => import('./UserSetting')
            },
            //钱包
            {
                path: 'wallet',
                name: 'user.wallet',
                meta: {
                    title: '我的钱包',
                    my: true,
                    header2: true,
                    pr0:true,
                    pl0:true
                },
                component: () => import('./UserWallet')
            },
            //我要充值
            // {
            //     path: 'recharge',
            //     name: 'user.recharge',
            //     meta: {
            //         title: '我要充值',
            //         my: true,
            //         header2: true
            //     },
            //     component: () => import('./UserRecharge')
            // },
            {
                path: 'withdraw',
                name: 'user.withdraw',
                meta: {
                    title: '余额提现',
                    my: true,
                    header2: true
                },
                component: () => import('./UserWidthdraw')
            },
            // {
            //     path: 'buy',
            //     name: 'user.buy',
            //     meta: {
            //         title: '我的',
            //         my: true,
            //         pr0: true,
            //         pl0: true
            //     },
            //     component: () => import('./UserBuy')
            // },
            // {
            //     path: 'sell',
            //     name: 'user.sell',
            //     meta: {
            //         title: '我的',
            //         my: true,
            //         pr0: true,
            //         pl0: true
            //     },
            //     component: () => import('./UserSell')
            // },
            {
                path: 'account/detail',
                name: 'account.detail',
                meta: {
                    title: '账务明细',
                    my: true,
                    header2: true
                },
                component: () => import('./AccountDetail')
            },
            {
                path: 'account/manage',
                name: 'account.manage',
                meta: {
                    title: '',
                    my: true,
                    header2: true,
                    pr0:true,
                    pl0:true,
                    unPullRefresh: true,
                    noBottom: true
                },
                component: () => import('./AccountManage')
            },
            {
                path: 'bind/account',
                name: 'bind.account',
                meta: {
                    title: '账号管理',
                    my: true,
                    header2: true,
                },
                component: () => import('./bind/UserBindAccount')
            },
            {
                path: 'notice',
                name: 'user.notice',
                meta: {
                    title: '我的',
                    my: true
                },
                component: () => import('./UserNotice')
            },
            // 支付密码
            {
                path: 'user/password',
                name: 'user.password',
                meta: {
                    title: '支付密码',
                    my: true,
                    header2: true
                },
                component: () => import('./UserPassword')
            },
            //用户协议
            {
                path: 'agreement',
                name: 'agreement',
                meta: {
                    title: '用户协议',
                    my: true,
                    unPullRefresh: true,
                    header2: true
                },
                component: () => import('./agreements/Agreement')
            },
            //隐私政策
            {
                path: 'policy',
                name: 'policy',
                meta: {
                    title: '隐私政策',
                    my: true,
                    unPullRefresh: true,
                    header2: true
                },
                component: () => import('./agreements/Policy')
            },
            //第三方服务共享清单
            {
                path: 'thirdparty',
                name: 'thirdparty',
                meta: {
                    title: '第三方服务共享清单',
                    my: true,
                    unPullRefresh: true,
                    header2: true
                },
                component: () => import('./agreements/ThirdParty')
            },
            //儿童个人信息保护规则及监护人须知
            {
                path: 'children',
                name: 'children',
                meta: {
                    title: '儿童个人信息保护规则及监护人须知',
                    my: true,
                    unPullRefresh: true,
                    header2: true
                },
                component: () => import('./agreements/Children')
            }, 
            {
                path: 'notice/detail',
                name: 'notice.detail',
                meta: {
                    title: '我的',
                    my: true,
                },
                component: () => import('./NoticeDetail')
            },
            {
                path: 'logoff',
                name: 'user.logoff',
                meta: {
                    title: '账号注销',
                    noBottom: true,
                    noheader: true,
                    unPullRefresh:true,
                    logoff: true
                },
                component: () => import('./logoff/UserLogoff')
            },
            // {
            //     path: 'collect',
            //     name: 'user.collect',
            //     meta: {
            //         title: '我的收藏',
            //         header2: true
            //     },
            //     component: () => import('./UserCollect')
            // },
            // new出售记录
            {
                path: 'sell/:status',
                name: 'user.sell',
                meta: {
                    title: '出售记录',
                    my: true,
                    header2: true,
                    unPullRefresh:true,
                    keepAlive: true
                },
                component: () => import('./RecordSell')
            },
            // new购买记录
            {
                path: 'buy/:status',
                name: 'user.buy',
                meta: {
                    title: '购买记录',
                    my: true,
                    header2: true,
                    unPullRefresh:true,
                    keepAlive: true
                },
                component: () => import('./RecordBuy')
            },
            // 我的商品
            {
                path: 'mygoods/:status',
                name: 'user.goods',
                meta: {
                    title: '我的商品',
                    my: true,
                    header2: true,
                    unPullRefresh:true,
                    // keepAlive: true
                },
                component: () => import('./UserGoods')
            },
            // 商品详情
            {
                path: 'order/detail',
                name: 'order.detail',
                meta: {
                    title: '寄售详情',
                    noBottom: true,
                    noheader: true,
                    pr0:true,
                    pl0:true,
                    unPullRefresh:true,
                },
                component: () => import('./OrderDetail')
            },
            //订单详情
            {
                path: 'goods/detail',
                name: 'goods.detail',
                meta: {
                    title: '订单详情',
                    noheader: true,
                    my: true,
                    pr0:true,
                    pl0:true,
                    noBottom:true,
                    unPullRefresh:true,
                },
                component: () => import('./GoodsDetail')
            },
            //订单详情 购买和出售
            {
                path: 'order',
                name: 'user.order',
                meta: {
                    title: '订单详情',
                    noheader: true,
                    my: true,
                    pr0:true,
                    pl0:true,
                    noBottom:true,
                    unPullRefresh:true,
                },
                component: () => import('./UserOrder')
            },
            //保证金流水记录
            {
                path: 'margin/detail',
                name: 'margin.detail',
                meta: {
                    title: '账务明细',
                    my: true,
                    header2:true
                },
                component: () => import('./MarginDetail')
            },
            //保证金充值
            {
                path: 'margin/recharge',
                name: 'margin.recharge',
                meta: {
                    title: '我要充值',
                    my: true,
                    header2:true
                },
                component: () => import('./MarginRecharge')
            },
            //保证金提现
            {
                path: 'margin/withdraw',
                name: 'margin.withdraw',
                meta: {
                    title: '保证金提现',
                    my: true,
                    header2: true
                },
                component: () => import('./MarginWithdraw')
            },
            //保证金提现
            {
                path: 'msg',
                name: 'user.msg',
                meta: {
                    title: '消息通知',
                    my: true,
                    header2: true,
                    noBottom: true,
                    unPullRefresh:true,
                    pr0:true,
                    pl0:true,
                    keepAlive: true
                },
                component: () => import('./UserMsg.vue')
            },
            {
                path: 'cashout',
                name: 'user.cashout',
                meta: {
                    title: '余额提现',
                    my: true,
                    header2: true,
                    noBottom: true,
                    unPullRefresh:true,
                    pr0:true,
                    pl0:true
                },
                component: () => import('./CashOut.vue')
            },
            //交易管家
            {
                path: 'butler',
                name: 'user.butler',
                meta: {
                    title: '交易管家',
                    noheader: true,
                    noBottom: true,
                    unPullRefresh: true,
                    pr0:true,
                    pl0:true,
                    usercenter:true
                },
                component: () => import('./UserButler.vue')
            }
        ]
    },
]
